var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGataca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 71",
    width: 71,
    height: 66,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector (3)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #4745b7 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m72.2 38.4c2.2 3.3 3.5 7.2 3.5 11.4 0 11.2-8.8 20.2-19.9 20.7q-0.4 0-0.8 0c-3 0-5.8-0.6-8.4-1.7q-2.1-1-3.8-2.3-1.1-0.8-2.1-1.7-1.3-1.2-2.3-2.6-0.5 0.6-1 1.2c-3.8 4.4-9.4 7.1-15.7 7.1-6.7 0-12.6-3.2-16.4-8.1-2.7-3.5-4.3-7.8-4.3-12.6 0-10.6 8-19.3 18.3-20.5-1.1-2.5-1.7-5.2-1.7-8.1 0-11.5 9.3-20.7 20.8-20.7 10.2 0 18.7 7.4 20.4 17.2q0.3 1.7 0.3 3.5c0 2.9-0.6 5.6-1.7 8.1 6.2 0.7 11.6 4.2 14.8 9.1zm-44.7-23.5c-3.4 6-1.4 13.5 4.5 17q0.1 0 0.2 0.1c2.4 1.3 5.1 1.8 7.7 1.5 1.5-0.2 3.1-0.7 4.5-1.4q0.2-0.2 0.4-0.3c1.8-1 3.3-2.5 4.4-4.4q0.7-1.3 1.1-2.6c1.7-5.4-0.6-11.5-5.7-14.4-6-3.4-13.6-1.4-17.1 4.5zm38.5 40.8c2-3.9 1.9-8.4-0.2-12-1-1.8-2.6-3.5-4.6-4.6-3.9-2.3-8.5-2.2-12.3-0.2q-0.2 0.2-0.4 0.3-0.9 0.5-1.7 1.2l13.6 7.8v0.1l-6.7 5.6-11-6.4-0.4-0.2-7-4-4.2-2.5-2.6-1.4q-0.2-0.2-0.4-0.3-0.1 0-0.2-0.1c-5.9-3.4-13.5-1.3-17 4.6-2.5 4.4-2.1 9.7 0.7 13.5 1 1.4 2.3 2.6 3.9 3.5 4.8 2.7 10.6 2 14.5-1.4l-12.4-7.1 6.8-5.6 9.6 5.5 0.4 0.2 7 4.1 5.6 3.2 1.8 1c3.3 1.9 7.3 2.3 10.9 0.9 2.6-1.1 4.8-3 6.3-5.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGataca);
export default __webpack_public_path__ + "static/media/gataca.93af267b024801edf360dba1b9bddcb0.svg";
export { ForwardRef as ReactComponent };